export default __webpack_public_path__ + "static/media/TokenPocket.fbdf34de.svg";